import React from 'react';
import useBlockStyles from '../common/useBlockStyles';

const SLIDING_TEXT_STYLE_OPTIONS = { defaultBackground: 'transparent' };

/**
 * SlidingTextRenderer - Renders infinite scrolling text marquee
 * Uses theme accent color as default background if not specified
 */
const SlidingTextRenderer = ({ block, theme = {} }) => {
  const { content } = block;
  const {
    items = ['Welcome'],
    speed = 'normal',
    separator = '•',
    textColor = '#ffffff',
    backgroundColor, // Can be null to use accent color
  } = content;

  // Use block style system for theme-resolved values
  const styles = useBlockStyles(content, theme, SLIDING_TEXT_STYLE_OPTIONS);
  const bgColor = backgroundColor || styles.accentColor;

  // Speed in seconds for one complete loop
  const speedMap = {
    slow: 40,
    normal: 25,
    fast: 15,
  };

  const duration = speedMap[speed] || speedMap.normal;

  // Build the text content with separators
  const buildTextContent = () => {
    return items.map((item, i) => (
      <span key={i} className="inline-flex items-center">
        <span className="mx-4 sm:mx-6 font-medium text-sm sm:text-base">{item}</span>
        <span className="opacity-60">{separator}</span>
      </span>
    ));
  };

  return (
    <div
      className="w-full overflow-hidden py-3 sm:py-4"
      style={{ backgroundColor: bgColor }}
    >
      {/* CSS for infinite scroll animation */}
      <style>{`
        @keyframes sliding-text-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .sliding-text-animate {
          animation: sliding-text-scroll ${duration}s linear infinite;
        }
        .sliding-text-animate:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div
        className="sliding-text-animate flex whitespace-nowrap"
        style={{ color: textColor }}
      >
        {/* Duplicate content for seamless loop */}
        <div className="flex items-center shrink-0">
          {buildTextContent()}
        </div>
        <div className="flex items-center shrink-0">
          {buildTextContent()}
        </div>
        <div className="flex items-center shrink-0">
          {buildTextContent()}
        </div>
        <div className="flex items-center shrink-0">
          {buildTextContent()}
        </div>
      </div>
    </div>
  );
};

export default SlidingTextRenderer;
